var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"width":"100%","outlined":""}},[_c('apexchart',{attrs:{"width":"500","type":"line","options":_vm.options,"series":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }